import { render, staticRenderFns } from "./UploadedFiles.vue?vue&type=template&id=56c0bdb3&"
import script from "./UploadedFiles.vue?vue&type=script&lang=js&"
export * from "./UploadedFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports